<div class="paymentDetailButton">
  <ng-container *ngIf="isMobile; else payBtn">
    <ng-container *ngIf="isFixed; else mobileContent">
      <app-fixed-surface
        [boxShadow]="true">
        <ng-container *ngTemplateOutlet="mobileContent"></ng-container>
      </app-fixed-surface>
    </ng-container>
  </ng-container>
</div>

<ng-template #mobileContent>
  <div class="paymentDetailButton__cont">
    <ng-container *ngIf="applyConversion">
      <div class="paymentDetailButton__convertionRateCont">
        <app-ds-typography
          [size]="fontSize.XS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.SemiBold"
          [text]="'BOOKING_MODULE.REFERENCE_PRICE' | transloco">
        </app-ds-typography>
        <div class="paymentDetailButton__convertionRateCont-price">
          <app-ds-typography
            [size]="fontSize.XS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="finalPrice | currencyFormat: currencyCode">
          </app-ds-typography>
        </div>
      </div>
    </ng-container>
    <app-benefit-cashback
      [totalPrice]="finalPrice"
      [currencyCode]="currencyCode"
      [productReference]="productReference"
      [benefitViewType]="benefitViewType">
    </app-benefit-cashback>
  
    <ng-container *ngTemplateOutlet="payBtn"></ng-container>
  </div>
</ng-template>

<ng-template #payBtn>
  <app-ds-button
    [isLoading]="isLoadingBooking"
    [isDisabled]="disabled"
    [type]="buttonType"
    [isBasket]="buttonWithPriceInfo"
    [labels]="{
      ButtonLabel: label | transloco,
      BasketLabel: buttonWithPriceInfo ? (applyConversion ? (finalPrice | exchangeCurrency: conversionRate) : finalPrice | currencyFormat: currencyCode) : ''
    }"
    [emitWhenDisabled]="true"
    (clickEvent)="payButton()">
  </app-ds-button>
</ng-template>
